<nz-spin [nzSpinning]="isSpinning">
  <div class="sales-portal-container">
    <div class="title-section">
      <div class="title">Workshop Acquisition Overview</div>
      <nz-date-picker
        nzMode="year"
        [nzAllowClear]="false"
        [(ngModel)]="targetYear"
        (ngModelChange)="handleDateChange($event)"
      ></nz-date-picker>
    </div>
    <div class="target-section-detail">
      <sp-circular-progress
        [text]="'Achievement Rate'"
        [progress]="salesPortalService.dealerTargetSummaryInfo.customerAchievedRate"
      ></sp-circular-progress>
      <div class="center">
        <div class="still-to-go">
          <span class="key">Still to GO</span>
          <span class="value"
                [class.value-0]="salesPortalService.dealerTargetSummaryInfo.customerStillToGo === 0">
            {{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.customerStillToGo) }}
          </span>
        </div>
        <div class="card-item-row">
          <div class="card-item">
            <div class="header header-light"></div>
            <div class="content-key">Workshop Acquisition Target</div>
            <div
              class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.targetCustomer) }}
            </div>
          </div>
        </div>
        <div class="card-item-row">
          <div class="card-item">
            <div class="header header-dark"></div>
            <div class="content-key">YTD Actual Workshop Acquisition</div>
            <div
              class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.actualCustomer) }}
            </div>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="right">
        <div class="card-item-row ">
          <div class="card-item qty">
            <div class="header"></div>
            <div class="content-key">Targets achieved Dealer Quantity</div>
            <div class="content-value">{{ salesPortalService.dealerTargetSummaryInfo.customerAchievedCount }}
              / {{ salesPortalService.dealerTargetSummaryInfo.dealerCount }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="title-section" style="margin-top: 40px">
      <div class="title">Procurement</div>
    </div>
    <!--Search-->
    <form [formGroup]="searchFormData">
      <div nz-row [nzGutter]="20">
        <div nz-col [nzSpan]="8">
          <nz-form-item class="search-form-item">
            <nz-form-label>Search</nz-form-label>
            <nz-form-control class="line">
              <div nz-row [nzGutter]="20">
                <div nz-col [nzSpan]="24">
                  <nz-input-group [nzSuffix]="suffixTemplateInfo">
                    <input nz-input type="text" formControlName="searchStr" placeholder="Dealer Code/Dealer Name"/>
                    <ng-template #suffixTemplateInfo>
                      <i class="search" (click)="handleSearch()"></i>
                    </ng-template>
                  </nz-input-group>
                </div>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="8">
          <nz-form-item class="search-form-item">
            <nz-form-label>Whether Target Achieved</nz-form-label>
            <nz-form-control class="line">
              <nz-select formControlName="customerTargetAchieved"
                         [nzSuffixIcon]="suffixSearch"
                         (ngModelChange)="getList()"
              >
                <nz-option nzValue="" nzLabel="All"></nz-option>
                <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                <nz-option [nzValue]="false" nzLabel="No"></nz-option>
              </nz-select>
              <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
    <!--Table-->
    <nz-table
      #basicTable
      [nzData]="listOfData"
      [nzScroll]="{ x: scrollX }"
      [nzFrontPagination]="false"
    >
      <thead>
      <tr>
        <th nzWidth="110px">Dealer Code</th>
        <th nzWidth="130px">Dealer Org Code</th>
        <th nzWidth="160px">Dealer Channel Code</th>
        <th nzWidth="110px">Dealer Name</th>
        <th nzWidth="110px">Dealer Area</th>
        <th [nzSortFn]="sortFn.targetCustomer" nzWidth="150px">Target Workshop Acquisition</th>
        <th [nzSortFn]="sortFn.ytdCustomer" nzWidth="170px">YTD Target Workshop Acquisition</th>
        <th [nzSortFn]="sortFn.currentTurnover" nzWidth="170px">YTD Actual Workshop Acquisition</th>
        <th [nzSortFn]="sortFn.stillToGo" nzWidth="150px">Still To Go</th>
        <th nzWidth="180px">Whether Target Achieved</th>
        <th nzWidth="230px">Whether Configuration Completed</th>
        <th nzRight nzWidth="100px">Action</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td>{{ data.dealerCode }}</td>
        <td>{{ data.dealerOrgCode }}</td>
        <td>{{ data.dealerChannelCode }}</td>
        <td>{{ data.dealerName }}</td>
        <td>{{ data.dealerArea }}</td>
        <td nzEllipsis>{{ salesPortalService.formatThousands(data.targetCustomer) }}</td>
        <td nzEllipsis>{{ salesPortalService.formatThousands(data.ytdCustomer) }}</td>
        <td nzEllipsis>{{ salesPortalService.formatThousands(data.actualCustomer) }}</td>
        <td nzEllipsis>{{ salesPortalService.formatThousands(data.customerStillToGo) }}</td>
        <td nzEllipsis>{{ data.customerStillToGo === 0 ? 'Yes' : 'No' }}</td>
        <td>{{ data.customerSplitStatus === 'Y' ? 'Yes' : 'No' }}</td>
        <td nzRight>
          <svg-icon [iconName]="'sales-portal-view-more.svg'" [size]="24" class="table-action-button"
                    (click)="handleToDetail(data)" title="view more"></svg-icon>
          <svg-icon [iconName]="'sales-portal-settings.svg'" [size]="24" class="table-action-button"
                    (click)="handleToSetting(data)" title="setting"></svg-icon>
        </td>
      </tr>
      </tbody>
    </nz-table>
  </div>
</nz-spin>

